<template>
  <div>
    <AchievementsHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">科技成果</a-breadcrumb-item>
        <a-breadcrumb-item>科技成果详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="tankName">{{ detail.name }}</div>
      <div class="infoBox">
        <a-descriptions :column="3">
          <a-descriptions-item label="技术领域">
            <dict-render :dict-obj="dictObjs['belong_techField']" v-if="detail.technoSphere"
              :text="detail.technoSphere"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="成熟度">
            <dict-render :dict-obj="dictObjs['technical_maturity']" v-if="detail.techMaturity"
              :text="detail.techMaturity"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="交易价格(万元)">{{ detail.transactionValue }}</a-descriptions-item>
          <a-descriptions-item label="成果类型">
            <dict-render :dict-obj="dictObjs['result_type']" v-if="detail.achievementClassify"
              :text="detail.achievementClassify"></dict-render>
          </a-descriptions-item>
          <a-descriptions-item label="合作方式">
            <dict-render :dict-obj="dictObjs['cooperation_methods']" v-if="detail.cooperationWay"
              :text="detail.cooperationWay"></dict-render>
          </a-descriptions-item>
        </a-descriptions>
        <div class="grayBox" v-if="isUserCode">
          <a-button style="background-color: #fc550b;color: #fff;" @click="onPass()">联系技术方</a-button>
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            成果介绍
          </div>
        </div>
        <div class="talentContentBox">
          {{ detail.achievementSynopsis }}
        </div>
      </div>
    </div>
    <LayoutFooter />
    <RecruitmentModal ref="recruitmentModal" :form-primary-key-field="listKeyField" @finish="onClose" />
  </div>
</template>
<script>
import { tableListMixin,dictMixin } from "@/mixins";
import AchievementsHeader from './achievementsHeader';
import { achievementFontInfo } from "@/api/achievementsService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';
import { message } from "ant-design-vue";
import RecruitmentModal from "./recruitmentModal";

export default {
  name: "noticeDetail",
  components: { AchievementsHeader, DictRender, LayoutFooter, RecruitmentModal },
  mixins: [tableListMixin,dictMixin],
  data() {
    return {
      dictNames: 'belong_techField,technical_maturity,result_type,cooperation_methods',
      companyJobList: {},
      detail: {},
      ellipsis: true,
      isUserCode: false
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: achievementFontInfo.detail,
        params: { id: this.$route.query.id }
      }).then(res => {
        this.detail = res
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/achievements/components/recruitment",
        query: { type: '科技成果' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/achievements/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation();
    },
    onPass() {
      if (this.isUserCode) {
        let obj = {
          ...this.detail,
          achievementsId: this.detail.id,
          receiveContact: this.detail.principal,
          receiveContactNumber: this.detail.principalPhone,
        }
        this.onShowModal('recruitmentModal', obj)
      } else {
        message.success("请登录后操作！")
      }
    }
  },
  mounted() {
    this.getDetail()
    this.isUserCode = this.$ls.get("roleCode").includes('user') || this.$ls.get("roleCode").includes('company')
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  // background: white;
}

.tutorBox {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;

  .tankName {
    margin-bottom: 18px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .infoBox {
    position: relative;
    padding: 20px;
    background-color: #ecf0f6;
    margin-bottom: 15px;
    font-size: 14px;
    color: #666;

    .grayBox {
      position: absolute;
      right: 5%;
      bottom: 30%;
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;
  background-color: #fff;

  .talentLeftBox {
    width: 100%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #fc550b;
      }
    }

    .talentContentBox {
      padding: 14px 20px;
      width: 100%;
      text-indent: 2em;
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #333;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #333;
}
</style>
